export type GenericErrorName =
  | 'USER_NOT_FOUND'
  | 'CONTENT_NOT_FOUND'
  | 'UNKNOWN_ERROR'
  | 'FAILED_TO_SEND_LOGS'

export type ErrorSettings = {
  name: GenericErrorName,
  message: string,
  subMessage?: string,
}

export class GenericError extends Error {
  name: GenericErrorName;
  message: string;
  subMessage?: string;
  cause?: any;

  constructor(err: GenericErrorName, cause?: any)
  constructor(
    err: unknown,
    cause?: any,
  ) {
    super()
    const parsed = this.parseError(err)

    this.name = parsed.name
    this.message = parsed.message
    this.subMessage = parsed.subMessage
    this.cause = cause
  }

  parseError(err: any): ErrorSettings {
    const appSyncError = typeof err === 'string'
      ? { message: err }
      : err?.errors?.at(0)

    switch (appSyncError?.message) {
      case 'USER_NOT_FOUND': {
        return {
          name: 'USER_NOT_FOUND',
          message: 'Cannot find session user',
        }
      }
      case 'CONTENT_NOT_FOUND': {
        return {
          name: 'CONTENT_NOT_FOUND',
          message: 'The content you are looking for could not be found',
          subMessage: 'Please contact the sender for more information',
        }
      }
      case 'FAILED_TO_SEND_LOGS': {
        return {
          name: 'FAILED_TO_SEND_LOGS',
          message: 'We have failed to submit logs to Alucio',
          subMessage: 'Please contact Alucio support for more information',
        }
      }
      default: {
        return {
          name: appSyncError?.message ?? 'UNKNOWN_ERROR',
          message: 'An unknown error has occured',
          subMessage: 'Please contact the sender for more information.',
        }
      }
    }
  }
}
